import { Box, Button, Flex, Text } from '@grupoboticario/flora-react'
import React from 'react'

import { IconWarning, IconWhatsapp } from '@/components/icons'
import useTracking from '@/hooks/tagManager.hook'
import { boxStyled, flexStyled, h2Styled } from '@/styles/home.style'
import { buttonStyled } from '@/styles/payment.style'

export const Home = () => {
  const track = useTracking()
  return (
    <Box css={boxStyled}>
      <Flex
        direction="column"
        align="center"
        justify="center"
        css={flexStyled}
        gapY={30}
      >
        <IconWarning />
        <Text as="h2" css={h2Styled}>
          Ops, não encontramos este link para pagamento.
        </Text>
        <Text align="center">
          Por favor entre em contato com a equipe responsável pela venda!
        </Text>
        <a href="https://api.whatsapp.com/send/?phone=558007440010&text=A+página+não+encontrou+meu+link+de+pagamento&app_absent=0">
          <Button
            leftIcon={<IconWhatsapp />}
            isUppercase
            css={buttonStyled}
            onClick={() =>
              track({
                event: `avisar_sobre_pedido_não_encontrado`,
                parameter: 'pedido_não_encontrado',
                value: true,
              })
            }
          >
            Avisar sobre este erro
          </Button>
        </a>
      </Flex>
    </Box>
  )
}

export default Home
